import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store'
import Home from '../views/Home.vue'
import Concurs from '../views/Concurs.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/contest',
        name: 'concurs',
        component: Concurs
    },
]

const router = new VueRouter({
    routes,
    mode: 'history',
});
router.beforeEach((to, from, next) => {
    store.commit('closePopup')
    next()
})
export default router
